var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.25,
    stroke: "#000064",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.742 38.582V21.944h-4.955v16.638M28.788 14h-4.954v3.552h4.954V14z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.786 37.835l4.955-4.954-5-5 5.023-5.025",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.48 21.944H17.524v-4.346h23.088l1.87 4.346z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.571 15.962H14v7.57h3.571v-7.57zM35.701 30.959a2.061 2.061 0 102.862-1.901 1.275 1.275 0 01-.8-1.17v-5.896M32.714 38.893H19.908v3.367h12.806v-3.367z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
export default SvgIconWorkCircle;